export function kendoMenu() {
	$("[kendo-menu]").each(function(idx) {
		let $ul = $(this);

		let menuOptions = {
			animation: {
				open: {effects: "fadeIn"},
				duration: 500
			},
			hoverDelay: 150,
			openOnClick: true,
		};
		$ul.kendoMenu(menuOptions).data("kendoMenu");
	})
}
